const disclaimerText = 'Sorry, our service isn\'t available currently in MN, but will be soon.'

export default disclaimerText



// WEBPACK FOOTER //
// ./src/constants/registration/minnesotaDisclaimerText.js